import "./Login.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";

function Login() {
    // Estados para gerenciamento do login
    const [blockedTime, setBlockedTime] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    // Função de estilização para erros
    function isErro() {
        const erro = document.querySelector("#erro");
        if (erro) {
            erro.innerHTML = "";
            document.querySelector("#email").style.borderColor = "white";
            document.querySelector("#password").style.borderColor = "white";
        }
    }

    // Funções para relógio de bloqueio por muitas tentativas
    function formatTime(time) {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    }

    function Relogio(props) {
        const dataExp = new Date(localStorage.getItem("tempo"));
        const dataAtual = new Date();

        if (props.blockedTime == 0) {
            if (dataExp > dataAtual) {
                let conta = Math.ceil((dataExp - dataAtual) / 1000);
                setBlockedTime(conta);
                setIsDisabled(true);
            } else {
                setIsDisabled(false);
            }
        }

        if (props.blockedTime > 0) {
            //setBlockedTime(localStorage.getItem("tempo"))
            return (
                <div id="relogio" classList="texto-branco">
                    Tempo de espera: {formatTime(props.blockedTime)}
                </div>
            );
        }
    }

    // Funções de estilização para quando o campo for selecionado
    function focusEmail() {
        let email = document.querySelector("#email").value;
        let emailCampo = document.querySelector("#email");
        if (email !== "") {
            emailCampo.classList.add("foco-pagamentos");
        } else {
            emailCampo.classList.remove("foco-pagamentos");
        }
    }

    function focusSenha() {
        let senha = document.querySelector("#password").value;
        let senhaCampo = document.querySelector("#password");
        if (senha !== "") {
            senhaCampo.classList.add("foco-pagamentos");
        } else {
            senhaCampo.classList.remove("foco-pagamentos");
        }
    }

    // Função de visualização de senha
    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    // useEffect para gerenciamento do relógio de muitas tentativas
    useEffect(() => {
        let interval = null;
        if (blockedTime > 0) {
            interval = setInterval(() => {
                setBlockedTime((prevTime) => prevTime - 1);
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [blockedTime]);

    // Função de envio para autenticação do login
    async function sign(event) {
        // Se estiver sendo chamado via keyDown, previne o comportamento padrão
        if (event) event.preventDefault();

        // Se já estiver enviando, ignora a nova tentativa
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const email = document.querySelector("#email").value;
            const password = document.querySelector("#password").value;
            const response = await axios.post(
                "/api/sign",
                {
                    email,
                    password,
                },
                {
                    withCredentials: true,
                }
            );
            console.log(response.data);
            if (response.data.status === 200) {
                // navigate("/");
                window.location = "/";
            } else if (
                response.data.status === 400 ||
                response.data.msg == undefined
            ) {
                console.log("entrou no inválido");
                const erro = document.querySelector("#erro");
                while (erro.firstChild) {
                    erro.removeChild(erro.firstChild);
                }
                setTimeout(() => {
                    document.querySelector("#email").style.borderColor = "red";
                    document.querySelector("#password").style.borderColor =
                        "red";
                    erro.classList.add("texto-vermelho");
                    let divText = document.createTextNode(
                        "Usuário e/ou senha inválidos!"
                    ); // Cria o elemento de texto
                    erro.appendChild(divText);
                }, 50); //Pequeno delay de criação apenas para deixar mais intuitivo
            } else {
                alert(response.data.msg);
                setBlockedTime(response.data.time);
                localStorage.setItem("tempo", response.data.date);
                setIsDisabled(true);
            }
        } catch (error) {
            // Altere a estrutura do seu tratamento de erro para lidar com os diferentes códigos de status HTTP
            alert(error);
            if (error.response == "O usuário já está sendo utilizado") {
                alert("O usuário já está sendo utilizado");
            }
            if (error.response) {
                if (error.response.status === 400) {
                    alert("Usuário e senha inválidos!");
                    // navigate("/login");
                } else {
                    console.error(
                        "Erro na resposta do servidor:",
                        error.response
                    );
                    alert(
                        `Erro na resposta do servidor: ${error.response.status} ${error.response.statusText}`
                    );
                    // navigate("/bad/request");
                }
            } else if (error.request) {
                console.error("Erro ao realizar a solicitação:", error.request);
                alert("Erro ao realizar a solicitação.");
                // navigate("/bad/request");
            } else {
                console.error(
                    "Erro ao configurar a solicitação:",
                    error.message
                );
                alert(`Erro ao configurar a solicitação: ${error.message}`);
                // navigate("/bad/request");
            }
        } finally {
            setIsSubmitting(false);
        }
    }

    // Handler para capturar a tecla Enter
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            sign(event);
        }
    };

    return (
        <div className="login-container-pagamentos">
            <div className="">
                <div className="card-body">
                    <div className="row">
                        <div className="form-container-1-pagamentos">
                            <div className="icon-heading">
                                <img
                                    src="/dist/img/marca_almeira_e_nogueira_fundo_colorido.png"
                                    alt="Logo Pagamentos"
                                    className="icon-img"
                                />
                            </div>
                            <div className="text-portal">
                                <p>AN Documentos</p>
                            </div>
                            <div className="description-portal">
                                <p>
                                    Gerencie seus processos mantendo e trocando
                                    documentos de forma fácil e segura com o AN
                                    Documentos.
                                </p>
                            </div>
                            <div className="wrapper-social">
                                <a
                                    href="https://www.linkedin.com/company/almeidaenogueira/"
                                    className="href-social">
                                    <div className="icon linkedin">
                                        <div className="tooltip">Linkedin</div>
                                        <div>
                                            <i className="fab fa-linkedin"></i>
                                        </div>
                                    </div>
                                </a>
                                <a
                                    href="https://www.instagram.com/almeidaenogueira/"
                                    className="href-social">
                                    <div className="icon instagram">
                                        <div className="tooltip">Instagram</div>
                                        <div>
                                            <i className="fab fa-instagram"></i>
                                        </div>
                                    </div>
                                </a>
                                <a
                                    href="https://www.youtube.com/@anadvogados8921"
                                    className="href-social">
                                    <div className="icon youtube">
                                        <div className="tooltip">Youtube</div>
                                        <div>
                                            <i className="fab fa-youtube"></i>
                                        </div>
                                    </div>
                                </a>
                                <a
                                    href="https://almeidaenogueira.com.br/"
                                    className="href-social">
                                    <div className="icon site">
                                        <div className="tooltip">Site</div>
                                        <div>
                                            <i className="fa fa-globe-americas"></i>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="form-container-2-pagamentos">
                            <h2 className="center-element">Login</h2>
                            <Relogio
                                blockedTime={blockedTime}
                                classList="text-white"
                            />

                            <div id="erro">{isErro()}</div>

                            <div className="row input-group-pagamentos">
                                <input
                                    type="email"
                                    id="email"
                                    className="campo-pagamentos"
                                    onChange={focusEmail}
                                    onKeyDown={handleKeyDown}
                                    disabled={isDisabled}
                                />
                                <label id="tag-email">Email</label>
                            </div>
                            <div className="row input-group-pagamentos-senha">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    className="campo-pagamentos"
                                    onChange={focusSenha}
                                    onKeyDown={handleKeyDown}
                                    disabled={isDisabled}
                                />
                                <label id="tag-senha">Senha</label>
                                <div className="show-hide-login">
                                    <IconButton
                                        onClick={togglePasswordVisibility}
                                        aria-label={
                                            showPassword
                                                ? "Ocultar senha"
                                                : "Mostrar senha"
                                        }>
                                        {showPassword ? (
                                            <VisibilityOffIcon />
                                        ) : (
                                            <VisibilityIcon />
                                        )}
                                    </IconButton>
                                </div>
                            </div>
                            <button
                                onClick={sign}
                                className="btn-entrar-pagamentos"
                                disabled={isDisabled || isSubmitting}>
                                Entrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
